const coursesData = [
  {
    title: "Графічний дизайн",
    thumbnail: "assets/Images/courses/22.jpg",
    authorImg: "assets/Images/advisors/advisor5.png",
    totalRate: "2350",
    price: "0",
    author: "Давид Герасічкин",
    rate: "4",
    authorPosition: "Javascript Developer",
    tag: "Figma, Canva, Photoshop",
    lessons: "10",
    path: "/course-details:1",
    support: "за підтримки ",
    supportImg: "assets/Images/sponsor/Logo_RAZOM_FOR-UKRIANE-1.png",
    supportUrl: "https://www.razomforukraine.org/",
    isArchived: true
  },
  
  {
    title: "Експерт офісу. Секретар",
    thumbnail: "assets/Images/courses/25.jpg",
    authorImg: "assets/Images/advisors/advisor6.png",
    
    totalRate: "3520",
    price: "0",
    author: "Валентин Рибинський",
    rate: "5",
    authorPosition: "React Native Developer",
    tag: "Google Docs, Microsoft Office",
    lessons: "10",
    path: "/course-details:2",
    support: "за підтримки ",
    supportImg: "assets/Images/sponsor/Logo_RAZOM_FOR-UKRIANE-1.png",
    supportUrl: "https://www.razomforukraine.org/",
    isArchived: true
  },
  // {
  //   title: "Коучинг",
  //   thumbnail: "/Assets/Images/courses/course_couch_1.png",
  //   authorImg: "Assets/Images/advisors/advisor3.png",
  //   totalRate: "3320",
  //   price: "75",
  //   author: "Наталія Зозуля",
  //   rate: "5",
  //   authorPosition: "PHP Developer",
  //   tag: "PHP, Laravel",
  //   lessons: "74",
  //   path: "/course-details:3"
  // },
  {
    title: "Менеджер колл центру",
    thumbnail: "assets/Images/courses/24.jpg",
    authorImg: "assets/Images/advisors/advisor1.png",
    totalRate: "520",
    price: "0",
    author: "Олексій Сіромолот",
    rate: "4",
    authorPosition: "Software Development",
    tag: "CRM, скріпти, аналіз конкурентів",
    lessons: "8",
    path: "/course-details:4",
    support: "за підтримки ",
    supportImg: "assets/Images/sponsor/Logo_RAZOM_FOR-UKRIANE-1.png",
    supportUrl: "https://www.razomforukraine.org/",
    isArchived: true
  },
  {
    title: "Штучний інтелект",
    thumbnail: "assets/Images/courses/15.jpg",
    authorImg: "assets/Images/advisors/advisor_vl.png",
    totalRate: "520",
    price: "0",
    author: "Владислав Мінаєв",
    rate: "4",
    authorPosition: "Software Development",
    tag: "ChatGPT, Нейромережі",
    lessons: "10",
    path: "/course-details:7",
    support: "за підтримки ",
    supportImg: "assets/Images/sponsor/Logo_RAZOM_FOR-UKRIANE-1.png",
    supportUrl: "https://www.razomforukraine.org/",
    isArchived: true
  },
  // {
  //   title: "Менеджер продаж",
  //   thumbnail: "assets/Images/courses/20.jpg",
  //   authorImg: "assets/Images/advisors/advisor2.png",
  //   totalRate: "3621",
  //   price: "0",
  //   author: "Євген Демченко",
  //   rate: "5",
  //   authorPosition: "Science And Arts",
  //   tag: "Основи продажів і лідерство",
  //   lessons: "8",
  //   path: "/course-details:5"
  // },
  {
    title: "Менеджер з продажу",
    thumbnail: "assets/Images/courses/20.jpg",
    authorImg: "assets/Images/advisors/advisor_pavl.png",
    totalRate: "3621",
    price: "0",
    author: "Влад Павлов",
    rate: "5",
    authorPosition: "Science And Arts",
    tag: "Основи продажів і лідерство",
    lessons: "8",
    path: "/course-details:5",
    support: "за підтримки ",
    supportImg: "assets/Images/sponsor/Logo_RAZOM_FOR-UKRIANE-1.png",
    supportUrl: "https://www.razomforukraine.org/",
    isArchived: true
  },
  {
    title: "Таргетолог",
    thumbnail: "assets/Images/courses/21.jpg",
    authorImg: "assets/Images/advisors/advisor4.png",
    totalRate: "452",
    price: "0",
    author: "Петро Лозинський",
    rate: "4",
    authorPosition: "Google ADS Editor, Analytics, YouTube",
    tag: "Google ADS, YouTube",
    lessons: "13",
    path: "/course-details:6",
    support: "за підтримки ",
    supportImg: "assets/Images/sponsor/Logo_RAZOM_FOR-UKRIANE-1.png",
    supportUrl: "https://www.razomforukraine.org/",
    isArchived: true
  },
  // {
  //   title: "Computer Science Course",
  //   thumbnail: "/Assets/Images/courses/courses_7.png",
  //   authorImg: "Assets/Images/profile/profile_7.png",
  //   totalRate: "1420",
  //   price: "69",
  //   author: "Jasmine A. Tully",
  //   rate: "5",
  //   authorPosition: "Software Developer",
  //   tag: "MERN, React",
  //   lessons: "39",
  // },
  // {
  //   title: "Full Stack Development",
  //   thumbnail: "/Assets/Images/courses/courses_8.png",
  //   authorImg: "Assets/Images/profile/profile_8.png",
  //   totalRate: "3620",
  //   price: "52",
  //   author: "Lester V. Ingram",
  //   rate: "4",
  //   authorPosition: "Software Developer",
  //   tag: "MERN, React, PHP",
  //   lessons: "30",
  // },
  // {
  //   title: "Program in Graphic Design",
  //   thumbnail: "/Assets/Images/courses/courses_9.png",
  //   authorImg: "Assets/Images/profile/profile_9.png",
  //   totalRate: "4510",
  //   price: "88",
  //   author: "Kim L. Liriano",
  //   rate: "4",
  //   authorPosition: "Graphic Design",
  //   tag: "Design, UI, UX",
  //   lessons: "50",
  // },

  {
    title: "Графічний дизайн",
    thumbnail: "assets/Images/courses/22.jpg",
    authorImg: "assets/Images/advisors/advisor_nata.png",
    totalRate: "2350",
    price: "5000",
    oldPrice: "8000", // Стара ціна
    author: "Кофанова Наталія",
    rate: "4",
    authorPosition: "Javascript Developer",
    tag: "Adobe Photoshop, Illustrator, InDesign",
    lessons: "12",
    path: "/course-details:9",
    support: "за підтримки ",
    supportImg: "",
    isArchived: true
  },
  {
    title: "Школа контентмейкінгу",
    thumbnail: "assets/Images/courses/22.jpg",
    authorImg: "assets/Images/advisors/advisor3.png",
    totalRate: "2350",
    price: "6000",
    oldPrice: "12000", // Стара ціна
    author: "Адаменко Анастасія",
    rate: "4",
    authorPosition: "Javascript Developer",
    tag: "TikTok, Instagram Reels, YouTube Shorts;",
    lessons: "12",
    path: "/course-details:13",
    support: "за підтримки ",
    supportImg: "",
    isArchived: true
  },
  // {
  //   title: "Експерт офісу. Секретар",
  //   thumbnail: "assets/Images/courses/25.jpg",
  //   authorImg: "assets/Images/advisors/advisor6.png",
    
  //   totalRate: "3520",
  //   price: "300",
  //   author: "Валентин Рибинський",
  //   rate: "5",
  //   authorPosition: "React Native Developer",
  //   tag: "Google Docs, Microsoft Office",
  //   lessons: "10",
  //   path: "/course-details:2",
  //   support: "за підтримки ",
  //   supportImg: ""
  // },
  // {
  //   title: "Менеджер колл центру",
  //   thumbnail: "assets/Images/courses/24.jpg",
  //   authorImg: "assets/Images/advisors/advisor1.png",
  //   totalRate: "520",
  //   price: "300",
  //   author: "Олексій Сіромолот",
  //   rate: "4",
  //   authorPosition: "Software Development",
  //   tag: "CRM, скріпти, аналіз конкурентів",
  //   lessons: "8",
  //   path: "/course-details:4",
  //   support: "за підтримки ",
  //   supportImg: ""
  // },
  // {
  //   title: "Штучний інтелект",
  //   thumbnail: "assets/Images/courses/15.jpg",
  //   authorImg: "assets/Images/advisors/advisor_vl.png",
  //   totalRate: "520",
  //   price: "300",
  //   author: "Владислав Мінаєв",
  //   rate: "4",
  //   authorPosition: "Software Development",
  //   tag: "ChatGPT, Нейромережі",
  //   lessons: "10",
  //   path: "/course-details:7",
  //   support: "за підтримки ",
  //   supportImg: ""
  // },
  // {
  //   title: "Менеджер з продажу",
  //   thumbnail: "assets/Images/courses/20.jpg",
  //   authorImg: "assets/Images/advisors/advisor_pavl.png",
  //   totalRate: "3621",
  //   price: "300",
  //   author: "Влад Павлов",
  //   rate: "5",
  //   authorPosition: "Science And Arts",
  //   tag: "Основи продажів і лідерство",
  //   lessons: "8",
  //   path: "/course-details:5",
  //   support: "за підтримки ",
  //   supportImg: ""
  // },
  {
    title: "Таргетолог",
    thumbnail: "assets/Images/courses/21.jpg",
    authorImg: "assets/Images/advisors/advisor4.png",
    totalRate: "452",
    price: "7600",
    oldPrice: "13200", // Стара ціна
    author: "Петро Лозинський",
    rate: "4",
    authorPosition: "Google ADS Editor, Analytics, YouTube",
    tag: "Google ADS, YouTube",
    lessons: "13",
    path: "/course-details:8",
    support: "за підтримки ",
    supportImg: "",
    isArchived: true
  },
  {
    title: "Комп’ютерна грамотність",
    thumbnail: "assets/Images/courses/child_1.png",
    authorImg: "assets/Images/advisors/advisor_kid.png",
    totalRate: "452",
    price: "1600",
    oldPrice: "2000", // Стара ціна
    author: "Діденко Петро",
    rate: "4",
    authorPosition: "Google ADS Editor, Analytics, YouTube",
    tag: "Windows, Google Doc, Canva",
    lessons: "12",
    path: "/course-details:10",
    support: "за підтримки ",
    supportImg: "",
    isArchived: true
  },

   {
    title: "Дитячий розмовний клуб з англійської",
    thumbnail: "assets/Images/courses/Eng_club.jpg",
    authorImg: "assets/Images/advisors/advisor_kid.png",
    totalRate: "452",
    price: "0",
    oldPrice: "2000", // Стара ціна
    author: "Панкратова Альона",
    rate: "4",
    authorPosition: "Google ADS Editor, Analytics, YouTube",
    tag: "Speaking",
    lessons: "2",
    path: "/course-details:14",
    support: "за підтримки ",
    supportImg: "",
    isArchived: false
  },
  {
    title: "Групові заняття з англійської для дітей",
    thumbnail: "assets/Images/courses/Eng_group.png",
    authorImg: "assets/Images/advisors/advisor_kid.png",
    totalRate: "452",
    price: "100",
    oldPrice: "250", // Стара ціна
    author: "Ангеліна Бучель",
    rate: "4",
    authorPosition: "Google ADS Editor, Analytics, YouTube",
    tag: "English",
    lessons: "2",
    path: "/course-details:15",
    support: "за підтримки ",
    supportImg: "",
    isArchived: false
  },
  // {
  //   title: "Штучний Інтелект",
  //   thumbnail: "assets/Images/courses/15.jpg",
  //   authorImg: "assets/Images/advisors/advisor_vl.png",
  //   totalRate: "452",
  //   price: "15000",
  //   oldPrice: "17000", // Стара ціна
  //   author: "Владислав Мінаєв",
  //   rate: "4",
  //   authorPosition: "Software Development",
  //   tag: "ChatGPT, Нейромережі",
  //   lessons: "12",
  //   path: "/course-details:11",
  //   support: "за підтримки ",
  //   supportImg: "",
  //   isArchived: true
  // },


  // {
  //   title: "Підготовка до НМТ",
  //   thumbnail: "assets/Images/courses/NMTNMT.jpg",
  //   authorImg: "assets/Images/advisors/imgon555566666.jpg",
  //   totalRate: "452",
  //   price: "0",
  //   oldPrice: "17000", // Стара ціна
  //   author: "Команда експертів та ШІ",
  //   rate: "4",
  //   authorPosition: "Software Development",
  //   tag: "ChatGPT, Нейромережі",
  //   lessons: "12",
  //   path: "/course-details:12",
  //   support: "за підтримки ",
  //   supportImg: "",
  //   isArchived: true
  // },
  
];

export default coursesData;
